module.exports = "/_next/static/images/9ffef41c51744ff0a5a442037a56c7b2-credit-card-limit@1x.png";